import React from 'react';
import {
  Grid,
  Button,
  TextField,
  InputAdornment,
  FormControl,
  MenuItem,
  Select,
} from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import {
  StyledHeadContainer,
  StyledTitleAssignement,
  StyledPrimaryButton,
  StyledButton,
  StyledFieldSpacing,
  StyledSecondHeadContainer,
} from 'containers/AttributionManager/styles';
import SearchIcon from 'images/search.svg';
import messages from 'containers/AttributionManager/messages';
import { translate } from 'containers/services/translate';
import AddIcon from 'images/add-icon.svg';
export interface UnassignedManagerHeadProps {
  intl: IntlShape;
  title: string;
  handleOpenUnassignedDialog: Function;
  setSelectAllUnassignedManagers: Function;
  selectAllUnassignedManagers: boolean;
  searchNameUnAssignedManager: string;
  handleChangeInputUnassignedSearch: Function;
  sortUnAssignedManager: string;
  handleChangeSortUnAssignedManager: Function;
  isTransactionAttribution?: boolean;
}

export const UnassignedManagerHead: React.FC<UnassignedManagerHeadProps> = (
  props,
): JSX.Element => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.handleChangeInputUnassignedSearch(e.target.value);
  };
  /* istanbul ignore next */
  const handleChangeSelect = (e: React.ChangeEvent<{ value: unknown }>) => {
    props.handleChangeSortUnAssignedManager(e.target.value);
  };
  return (
    <Grid
      item
      style={
        props.isTransactionAttribution
          ? StyledSecondHeadContainer
          : StyledHeadContainer
      }
    >
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between"
      >
        <Grid item>
          <span style={StyledTitleAssignement}>{props.title}</span>
        </Grid>
        {!props.selectAllUnassignedManagers && (
          <Grid item xs={6}>
            <Grid container direction="row" alignItems="center" spacing={1}>
              <Grid item xs>
                <TextField
                  name="search-field-unassigned"
                  value={props.searchNameUnAssignedManager}
                  label={translate(messages.searchField, props)}
                  onChange={handleChange}
                  style={StyledFieldSpacing}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <img src={SearchIcon} alt="search" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={props.isTransactionAttribution ? 5 : 6}>
                <FormControl
                  variant="standard"
                  style={{ width: '100%', marginTop: '-6px' }}
                >
                  <Select
                    data-testId={'select'}
                    value={props.sortUnAssignedManager}
                    onChange={handleChangeSelect}
                    defaultValue={'alphaOrder'}
                    style={{
                      width: '100%',
                      fontWeight: 700,
                    }}
                  >
                    <MenuItem data-testId={'desc'} value={'desc'}>
                      {translate(messages.busierTitle, props)}
                    </MenuItem>
                    <MenuItem data-testId={'asc'} value={'asc'}>
                      {translate(messages.lessBusyTitle, props)}
                    </MenuItem>
                    <MenuItem data-testId={'alphaOrder'} value={'alphaOrder'}>
                      {translate(messages.alphabeticalOrder, props)}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item>
          {props.selectAllUnassignedManagers ? (
            <Grid container direction="row" alignItems="center" spacing={1}>
              <Grid item>
                <Button
                  style={{ ...(StyledButton as any) }}
                  data-testId={'cancel-unassigned-button'}
                  onClick={() => {
                    props.setSelectAllUnassignedManagers(false);
                  }}
                >
                  <span>{translate(messages.cancelSelectionTitle, props)}</span>
                </Button>
              </Grid>
              <Grid item>
                <Button
                  style={{ ...(StyledPrimaryButton as any) }}
                  data-testId={'assign-button'}
                  onClick={() => props.handleOpenUnassignedDialog()}
                >
                  <Grid container direction="row" alignItems="center">
                    <Grid item>
                      <img
                        src={AddIcon}
                        style={{ marginTop: '4px' }}
                        alt="add"
                      />
                    </Grid>
                    <Grid item>
                      <span>
                        {translate(messages.assignButtonTitle, props)}
                      </span>
                    </Grid>
                  </Grid>
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Button
              style={{ ...(StyledButton as any) }}
              data-testId={'select-all-unassigned-button'}
              onClick={() => {
                props.setSelectAllUnassignedManagers(true);
              }}
            >
              <span>
                {translate(messages.selectAllUnassignedManagerTitle, props)}
              </span>
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default injectIntl(UnassignedManagerHead);
